<div class="main-debit-list">
    <app-filter></app-filter>
    <div class="content">
        <div *ngIf="filterOpen | async" (click)="closeFilter()" class="balck-background"></div>

      <div class="debit-details-table">
            <h2>פירוט הוראות הקבע</h2>
            <div class="debit-table">
                <div class="mat-elevation-z8">
                    <app-direct-debit-table></app-direct-debit-table>

                    <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator> -->
                </div>
            </div>
        </div>
        <h3 *ngIf="contents">{{ contents.mainDebitList.textAboveButton }}</h3>
        <div class="button-wrapper">
            <a *ngIf="contents" (click)="goToDirectDebit()" class="brand-button aqua-button" id="take-me" title=""
                ><span>{{ contents.mainDebitList.textButton }}</span></a
            >
        </div>
    </div>
</div>
